// libs
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";

// apis
import {
    getInternationalizationData,
    setInternationalizationData,
    setInternationalizationDataOnServer,
} from "shared/api/internationalization";

// constants
import { API_CACHE_TTL } from "shared/constants";

// store
import { ActionTypes } from "./actions";

// helpers
import MemoizeAPIWithTTL from "shared/helpers/memoizeAPIWithTTL";
import logger from "shared/logger";

// defs
import { IHeadersObject } from "global";

// NOTE: these values has to be in small case only
const requiredHeaders = ["x-country-code", "x-base-country-code", "x-ua-device-type"];
const memoizedGetI18NData = MemoizeAPIWithTTL(getInternationalizationData, API_CACHE_TTL);

interface II18FetchDataProps {
    defaultCurrency?: string;
    defaultCountry?: string;
    ssrHeaders: IHeadersObject;
}

export const I18FetchData = ({
    defaultCurrency,
    defaultCountry,
    ssrHeaders,
}: II18FetchDataProps): any => {
    return (dispatch: any) => {
        dispatch({ type: ActionTypes.INTERNATIONALIZATION_PROCESSING });

        const headers: typeof ssrHeaders = {};

        Object.keys(ssrHeaders)
            .sort()
            .forEach(key => {
                if (requiredHeaders.includes(key)) {
                    headers[key] = ssrHeaders[key];
                }
            });

        return memoizedGetI18NData({ headers })
            .then(data => {
                if (isEmpty(data) || isEmpty(data.response)) {
                    logger.error({ ERROR: "MANDATORY_FIELD_EMPTY", METHOD_NAME: "I18FetchData" });
                }
                const res = data.response;

                res.onGDPRNetwork = data.onGDPRNetwork;
                if (!isEmpty(defaultCurrency)) {
                    res.default.currency = defaultCurrency;
                    res.default.currencyDisplayValue = find(res.currencies, {
                        currencyCode: defaultCurrency,
                    }).currencyDisplayValue;
                }

                if (!isEmpty(defaultCountry)) {
                    res.default.countryCode = defaultCountry;
                    res.default.country = find(res.countries, {
                        countryCode: defaultCountry,
                    }).countryName;
                }

                res.isXHRAllowed = !res.onGDPRNetwork;

                dispatch({ type: ActionTypes.INTERNATIONALIZATION_SUCCESS, payload: res });
                return data;
            })
            .catch(() => {
                dispatch({ type: ActionTypes.INTERNATIONALIZATION_FAILED });
            });
    };
};

export const setData = (body: object): any => {
    return (dispatch: any) => {
        dispatch({ type: ActionTypes.INTERNATIONALIZATION_PROCESSING });
        const promise = setInternationalizationData(body);
        const promiseServer = setInternationalizationDataOnServer(body);

        return (
            Promise.all([promise, promiseServer])
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                .then(([_, data]: [any, Response]) => {
                    dispatch({ type: ActionTypes.SET_INTERNATIONALIZATION_SUCCESS });
                    return data;
                })
                .catch(() => {
                    dispatch({ type: ActionTypes.INTERNATIONALIZATION_FAILED });
                })
        );
    };
};
